
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ToasterService } from './toaster-service.service';
import { Constants } from '../pipes/constants';

export type HandleError = <T>(operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandler {
  constructor(private toasterService: ToasterService) {}

  createHandleError = (serviceName = '') => <T>(
    operation = 'operation',
    result = {} as T
  ) => this.handleError(serviceName, operation, result);

  private handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(error); // Always log

      const message = error.error
        ? error.error.message
        : `Server returned code ${error.status} with body "${error.error}"`;
        
        const jsonString = message.substring(message.indexOf(':') + 1).trim();

  // Step 2: Now safely parse
  const parsed = JSON.parse(jsonString);
      // Send to central MessageService
      this.toasterService.setting1();
      this.toasterService.error(Constants.TOASTER_RESPONSE_TYPE_ERROR, parsed[0].message);
      // Keep app running by returning safe result
      return of(result);
    };
  }
}
